<template>
    <div id="complementary-analysis-box" class="bg-success">
        <h2>Complimentary Analysis</h2>
        <p>
            Your results were emailed.
            Would you like one of our experts to walk you through these results?
        </p>
        <div class="tel-number-book-me-in">
            <input type="text" v-model="phoneDefault" class="form-control phone-input" :disabled="bookMeInSubmit">
            <button type="button" class="btn btn-light text-success book-me-in" v-on:click="changePhoneNumber" :disabled="bookMeInSubmit"><span v-show="!bookMeInSubmit">Book me in</span><span v-show="bookMeInSubmit">&#x2714;</span></button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "complementary-analysis-box",
        data () {
          return {

          }
        },
        props: {
            phoneNumber: String,
            bookMeInSubmit: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            email() {
                return this.$store.state.email;
            },
            phoneDefault: {
                get: function () {
                    return this.phoneNumber;
                },
                set: function (newPhone) {
                    this.phoneNumber = newPhone;
                    this.$store.commit('phoneNumber', this.phoneNumber);
                }
            },
            name() {
                return this.$store.state.name;
            },
            userType() {
                return this.$store.state.userType;
            }
        },
        methods: {
            changePhoneNumber: function () {

                if(this.phoneValidation()) {
                    axios.post('/index.php/wp-json/cashflow-calculator/cashflow-calculator-data-change-phone/', {
                        email: this.email,
                        phone: this.phoneNumber,
                        name: this.name,
                        user_type: this.userType
                    }).then(response => {})
                        .catch(e => {

                        });

                    this.$store.commit('wantsContact', true);

                    if (typeof gtag === 'function') {
                        gtag('event', 'Click', {
                            'event_category': 'CashflowCalculator',
                            'event_label': 'Step4-Book'});
                    }
                }
            },
            setPhoneNumber: function (newPhoneNumber) {
                this.$store.commit('phoneNumber', newPhoneNumber);
            },
            phoneValidation() {
                return this.phoneDefault.length > 0;
            }
        }
    }
</script>

<style scoped>

    #complementary-analysis-box {
        color: #fff;
        width: 85%;
        margin: 0 auto;
        margin-top: 15px;
        margin-bottom: 15px;
        padding-bottom: 15px;
        text-align: center;
        height: 100%;
    }

    p {
        text-align: left;
        margin: 0 auto;
        display: inline-block;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 15px;
    }

    .book-me-in {
        font-weight: bold;
        border: 1px solid #465978;
        width: 116px;
        margin-bottom: 5px;
    }

    .phone-input {
        border: solid 1px #fff;
        background-color: #28a745;
        color: #fff;
        width: 130px;
        margin: 0 auto;
        margin-bottom: 15px;
        text-align: center;
        display: inline-block;
    }

    @media (min-width: 1024px) {
        #complementary-analysis-box {
            margin-top: 0;
            padding-top: 15px;
        }

        h2 {
            margin-top: 15px;
            margin-left: 15px;
            margin-right: 15px;
            font-size: 26px;
        }

        p {
            max-width: 313px;
            margin-bottom: 0;
            margin-left: 20px;
            margin-right: 20px;
        }

        .first-box p {
            text-align: center;
            margin-left: 20px;
            margin-right: 20px;
        }

        .first-box .tel-number-book-me-in {
            margin: 20px auto;
        }

        .first-box button {
            display: block;
            margin: 0 auto;
        }

        .first-box .tel-number {
            margin-bottom: 25px;
        }

        .second-box .tel-number-book-me-in {
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .second-box p {
            margin-left: 20px;
            margin-right: 20px;
        }

        .first-box .book-me-in {
            margin-bottom: 20px;
        }

        .phone-input {
            display: block;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/ComplementaryAnalysisBox.vue